export default function updateAllItems(items, varName, payload) {
    return items.map((item) => {
        item[varName] = payload;
        return item;
    });
}
